"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeNonspecificConstruction = exports.serializeNonspecificConstruction = void 0;
const serializeNonspecificConstruction = (construction) => {
    return JSON.stringify(construction);
};
exports.serializeNonspecificConstruction = serializeNonspecificConstruction;
const deserializeNonspecificConstruction = (construction) => {
    const deserial = JSON.parse(construction);
    for (let i = 0; i < deserial.actionDatas.length; i++) {
        if (!deserial.actionDatas[i].buildActionInputs) {
            throw "The given serialized string does not have the proper structure";
        }
    }
    return deserial;
};
exports.deserializeNonspecificConstruction = deserializeNonspecificConstruction;
